module.exports = __webpack_public_path__ + "static/img/news4.d2ce357.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news1/news4.png
// module id = hE0s
// module chunks = 1